import LoadingSpinner from 'components/Common/Loading/LoadingSpinner'

/** Placeholder for the timeline/list panels while the first itinerary fetch resolves. */
function RightPanelLoadingState() {
  return (
    <div data-testid="right-panel-loading-state">
      <LoadingSpinner size={24} />
    </div>
  )
}

export default RightPanelLoadingState
